import { useCreateProductList } from 'api-hooks/product/list';
import { Notification, KIND } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import notification from 'components/common/notification';
import useDismiss from 'hooks/use-dismiss';
import useGetCrudPermission from 'hooks/use-get-crud-permission';
import useNavigation from 'hooks/use-navigation';
import { SeparatorVertical } from 'legacy-modules/styles';
import * as React from 'react';
import { NavigationProps } from 'types';

import ProductListForm from './components/form';

export type ProductListCreateParams = null;

export default function ProductListCreate(
  props: NavigationProps<NavigationRoutes.ProductsCreate>,
) {
  const { navigate } = useNavigation();

  const { mutateAsync, error } = useCreateProductList();

  const onDismiss = useDismiss('products');
  const permission = useGetCrudPermission('products');
  return (
    <>
      <ProductListForm
        {...props}
        renderError={
          !!error &&
          !!error.message && (
            <>
              <Notification
                overrides={{
                  Body: { style: { width: 'auto', wordBreak: 'break-all' } },
                }}
                kind={KIND.negative}
                closeable
              >
                {() => error.message}
              </Notification>
              <SeparatorVertical $margin={8} />
            </>
          )
        }
        onSubmit={async (input, form) => {
          const result = await mutateAsync(input);

          onDismiss();

          if (permission.view) {
            navigate(NavigationRoutes.ProductsView, {
              id: result.data?.id,
            });
          }

          notification.success({ message: result?.message });

          return result.data;
        }}
      />
    </>
  );
}
